import {Injectable} from '@angular/core';
import {Actions, createEffect, ofType} from '@ngrx/effects';
import {switchMap} from "rxjs/operators";
import * as fromWardGql from "./ward.graphql";
import {BaseResponse} from "../../../../../common/interfaces/global-interfaces";
import {GraphqlService} from "../../../../../services/graphql.service";
import {WardActions} from "./ward.actions";
import {Ward} from "./ward.model";


@Injectable()
export class WardEffects {

  loadData$ = createEffect(() => this.actions$.pipe(
    ofType(WardActions.getAllWardsByDistrict),
    switchMap((action) => this.apollo.queryObservable({
        query: fromWardGql.ALL_WARDS_BY_DISTRICT,
        variables: {districtUniqueId: action.districtUniqueId}
      })
    ),
    switchMap((response: any) => {
      const result: BaseResponse<Ward[]> = Object.values(Object.values(response)[0])[0];
      if (result?.response?.status) {
        return [
          WardActions.loadWards({wards: result?.data || []}),
          WardActions.wardsLoadingState({loading: false})
        ]
      } else {
        return [WardActions.wardsLoadingState({loading: false})]
      }
    })
  ));

  constructor(
    private actions$: Actions,
    private apollo: GraphqlService,
  ) {
  }

}
